import useKeyboardListener from "@/common/hooks/useKeyboardListener";
import { useAudioPlayback } from "@/common/hooks/useAudioPlayback.ts";
import { useKeyboardShortcutAudioControl } from "./useKeyboardShortcutAudioControl";
import { KeyboardEventHandlerOptions } from "@/types/types.ts";

export const useKeyboardShortcutTogglePlay = (options?: KeyboardEventHandlerOptions): void => {
  const { withShortcutCheck } = useKeyboardShortcutAudioControl(options);
  const { togglePlay } = useAudioPlayback();

  useKeyboardListener(
    withShortcutCheck((event) => {
      if (event.ctrlKey) return;

      if (event.key === " " || event.keyCode === 32) {
        event.preventDefault();
        togglePlay();
      }
    })
  );
};